const situations = [
  'запрос дополнительного бюджета;',
  'защита численности команды;',
  'обсуждение невыполнения плана;',
  'защита управленческого решения;',
  'несогласие с решением руководства;',
  'необходимость изменить приоритеты;',
  'обсуждение ресурсов;',
  'переговоры о целях и KPI;',
  'объяснение рисков;',
  'просьба о дополнительных полномочиях.',
];

export default function UpwardNegotiations() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Переговоры с собственником и вышестоящим руководством
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как руководителю отстаивать свою позицию наверх — один из самых сложных и важных навыков
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-arrow-up-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Руководителю необходимо не просто высказать мнение, а сформировать позицию, аргументировать её и показать последствия альтернативных решений.
          </p>
        </div>
      </div>
    </section>
  );
}